import clsx from "clsx";
import React from "react";
import SortIcon from "../Icons/SortIcon";
import CustomTooltip from "../Tooltip";

interface TableHeaderProps {
  header: any;
  handleSort?: (columnId: string) => void;
  columnWidths: Record<string, number>;
  sortByColumn?: string;
  sortByOrder?: string;
  handleColumnResize: (e: React.MouseEvent, columnId: string) => void;
  isStickyFirstColumn?: boolean;
  stickyLeft?: number;
}

const TableHeaders: React.FC<TableHeaderProps> = ({
  header,
  handleSort,
  columnWidths,
  sortByColumn,
  sortByOrder,
  handleColumnResize,
  isStickyFirstColumn,
  stickyLeft,
}) => {
  const columnWidth = columnWidths[header?.id] ?? 150;

  return (
    <th
      key={header.id}
      style={{
        width: columnWidth,
        minWidth: columnWidth,
        maxWidth: columnWidth * 2.5, // just dummy max width
        textAlign: header.align ?? "left",
        position: isStickyFirstColumn ? "sticky" : "relative",
        left: isStickyFirstColumn ? stickyLeft ?? 0 : undefined,
        zIndex: isStickyFirstColumn ? 30 : undefined,
        background: isStickyFirstColumn ? "#F4F5F7" : "#F4F5F7",
      }}
      className={clsx(
        "p-[4px] text-sm font-normal text-[#79808A] group-hover:bg-[#ECEEF2] bg-[#E9ECF2]",
        header.className
      )}
    >
      <div className="flex flex-row items-center gap-[2px] w-full min-w-max ">
        <span className="flex gap-2 items-center">
          {header.name}
          {header.sortable && (
            <button
              onClick={() => handleSort?.(header?.id)}
              className={`opacity-0 group-hover:opacity-100 transition-opacity ${
                sortByColumn === header.id ? "opacity-100" : ""
              }`}
            >
              <CustomTooltip text="Sort">
                <div
                  className={`transition-transform ${
                    sortByColumn === header.id && sortByOrder === "desc"
                      ? "rotate-180"
                      : ""
                  }`}
                >
                  <SortIcon />
                </div>
              </CustomTooltip>
            </button>
          )}
        </span>
      </div>
      {header.resizable && (
        <div
          className="resize-handle absolute right-0 top-1/2 -translate-y-1/2 h-[24px] w-[4px] bg-[#5A8DF1] rounded cursor-col-resize opacity-0 hover:opacity-100 hover:opacity-100 transition-opacity duration-200 z-10"
          onMouseDown={(e) => handleColumnResize(e, header.id)}
        />
      )}
    </th>
  );
};

export default TableHeaders;
